import axios from "../../utils/axios_interceptor"
import { getAcApiUrl } from "../../utils/helper";
import { getAccessHeader, getADA } from "../../utils/loginSession";

//for Terms & Conditions
const SET_TNC_STATE = "SET_TNC_STATE";
const SET_CHATBOT_STATE = "SET_CHATBOT_STATE";
const SET_NEWHATBOT_STATE = "SET_NEWHATBOT_STATE";

export const fetchTermsConditionsState = (state) => async (dispatch) => {
  let login = getAccessHeader(state);
  let tnc = localStorage.getItem("sharebarTNC");
  if (tnc == undefined) {
    try {
      const apiUrl = getAcApiUrl();
      const res = await axios({
        //headers: login,
        method: 'post',
        url: `${apiUrl}/anon/shareBarTermsAndConditions`,
        data: {}
      });
      tnc = res.data;
      localStorage.setItem("sharebarTNC", JSON.stringify(tnc));
    } catch (err) { }
  }
  else {
    tnc = JSON.parse(tnc);
  }

  let userAgreed = localStorage.getItem("sharebarTNCAgreed");
  if (userAgreed == undefined && getADA(state) !== '') {
    const apiUrl = getAcApiUrl();
    const resAgreed = await axios({
      headers: login,
      method: 'post',
      url: `${apiUrl}/getShareBarAgreedPolicy`,
      data: {
        "loginAda": getADA(state),
        "policyVersion": String(tnc._version)
      }
    });

    userAgreed = resAgreed.data;
    localStorage.setItem("sharebarTNCAgreed", userAgreed);
  }

  dispatch(setTNCState(tnc));
};

export const fetchChatbotState = (state) => async (dispatch) => {
  let chatbot = localStorage.getItem("chatbot");
  if (!chatbot || chatbot == undefined || chatbot === "undefined") {
    const apiUrl = getAcApiUrl();
    const res = await axios({
      method: 'post',
      url: `${apiUrl}/anon/chatbot`,
      data: {}
    });
    chatbot = res.data;
    localStorage.setItem("chatbot", JSON.stringify(chatbot));
    return chatbot
  }
  else {
    chatbot = JSON.parse(chatbot);
  }

  dispatch(setCHATBOTState(chatbot));
};

export const fetchNewChatbotState = (state) => async (dispatch) => {
  let adaChatBot = localStorage.getItem("adaChatBot");
  if (!adaChatBot || adaChatBot == undefined || adaChatBot === "undefined") {
    const apiUrl = getAcApiUrl();
    const res = await axios({
      method: 'post',
      url: `${apiUrl}/anon/adaChatBot`,
      data: {}
    });
    adaChatBot = res.data;
    localStorage.setItem("adaChatBot", JSON.stringify(adaChatBot));
    return adaChatBot
  }
  else {
    adaChatBot = JSON.parse(adaChatBot);
  }

  dispatch(setNEWCHATBOTState(adaChatBot));
  return adaChatBot
};


{/* TEP-16571 訪客購物 start */ }
export const fetchGuestContentStackWriting = async () => {
  const apiUrl = getAcApiUrl();
  const res = await axios({
    method: 'post',
    url: `${apiUrl}/anon/guestContentStackWriting`,
    data: {}
  });
  return res
};
{/* TEP-16571 訪客購物 End */ }
export const setTNCState = (state) => {
  return {
    type: SET_TNC_STATE,
    payload: state,
  };
};

export const setCHATBOTState = (state) => {
  return {
    type: SET_CHATBOT_STATE,
    payload: state,
  };
};

export const setNEWCHATBOTState = (state) => {
  return {
    type: SET_NEWHATBOT_STATE,
    payload: state,
  };
};

const termsConditionsState = (state = {}, action) => {
  switch (action.type) {
    case SET_TNC_STATE:
      return {
        ...state,
        tnc: action.payload,
      }
    default:
      return state;
  }
};
const chatbotState = (state = {}, action) => {
  switch (action.type) {
    case SET_CHATBOT_STATE:
      return {
        ...state,
        chatbot: action.payload,
      }
    default:
      return state;
  }
};
const newChatBotState = (state = {}, action) => {
  switch (action.type) {
    case SET_NEWHATBOT_STATE:
      return {
        ...state,
        adaChatbot: action.payload,
      }
    default:
      return state;
  }
};

export default {
  termsConditionsState,
  chatbotState,
  newChatBotState,
  fetchGuestContentStackWriting
};
